import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Chat } from 'app/layout/common/quick-chat/quick-chat.types';
import { AuthService } from 'app/core/auth/auth.service';
import { DataService } from 'app/services/data.service';
import { GridService } from 'app/services/grid.service';
import { BehaviorSubject, map, Observable, of, switchMap, tap, throwError } from 'rxjs';

@Injectable({providedIn: 'root'})
export class QuickChatService
{
    private _chat: BehaviorSubject<Chat> = new BehaviorSubject(null);
    private _chats: BehaviorSubject<Chat[]> = new BehaviorSubject<Chat[]>(null);
    user: any; // Assicurati di avere l'ID dell'utente corrente

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private authService: AuthService, private dataService: DataService, private gridService: GridService)
    {
        this.user = this.authService.user;
        //console.log("UserId QuickChat ", this.user);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------


    getChats(): Observable<Chat[]> {
        return this.dataService.getScopeData("CHATS", "CHATS.DEFAULT").pipe(
            map((response: any) => {

                // Assumi che la risposta contenga un oggetto con una proprietà 'data' che è l'array di chat
                const chats = response.data;
                return chats.filter(chat => 
                    chat.ChatUsers.some(user => user.User.value === this.user.id)
                );
            }),
            tap((filteredChats: Chat[]) => {
                this._chats.next(filteredChats);
            })
        );
    }
    
    

    /**
     * Getter for chat
     */
    get chat$(): Observable<Chat>
    {
        return this._chat.asObservable();
    }

    /**
     * Getter for chat
     */
    get chats$(): Observable<Chat[]>
    {
        return this._chats.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    /**
     * Get chat
     *
     * @param id
     */
    getChatById(id: string): Observable<any> {
        return this.dataService.getScopeData("CHATS", "CHATS.DEFAULT").pipe(
            map((response: any) => {
                // Recupera le chat dalla risposta
                const chats = response.data;
    
                // Trova la chat con l'id corrispondente
                return chats.find(chat => chat._id === id);
            }),
            tap((chat: Chat) => {
                if (chat) {
                    this._chat.next(chat); // Aggiorna lo stato della chat
                } else {
                    //console.error('Could not found chat with id of ' + id + '!');
                    throw new Error('Could not found chat with id of ' + id + '!');
                }
            })
        );
    }

    sendMessage(message: any, parentChat: any): Observable<any>{


        const readStatusConst = [
            {
                _id: this.makeid(),  
                User: this.user.id,  
                Read: true,
                ReadDate:  new Date().toISOString()        
            }
        ];
    
        for (let i = 0; i < parentChat.ChatUsers.length; i++) {
            readStatusConst.push({
                _id: this.makeid(),      
                User: parentChat.ChatUsers[i].User.value, 
                Read: false,
                ReadDate: null          
            });
        }

        const requestData = {
            _id: "#NEWID#", 
            Content: message, 
            Deleted: false, 
            DomCode: "D00000001", 
            ParentChat: parentChat._id, 
            SendDate: new Date().toISOString(), 
            ReadStatus: readStatusConst,
            Sender: this.user.id, 
            Title: "TEMP TITLE" 
        };
        return this.gridService.saveScopeData("CHATMESSAGES", "UPSERT", requestData, false);

    }

    createChat(title: any, chatUser: any): Observable<any>{


        const chatUserConst = [
            {
                _id: this.makeid(),  
                User: this.user.id,  
                Owner: true         
            }
        ];
    
        for (let i = 0; i < chatUser.length; i++) {
            chatUserConst.push({
                _id: this.makeid(),      
                User: chatUser[i].userId, 
                Owner: false             
            });
        }

        const requestData = {
            _id: "#NEWID#", 
            ChatUsers: chatUserConst, 
            Deleted: false, 
            DomCode: "D00000001", 
            Title: title
        };
        return this.gridService.saveScopeData("CHATS", "UPSERT", requestData, false);

    }


    makeid() {
        var length = 10;
      
        var id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, length);
        return id;
      }
    
    
}
